export default __webpack_public_path__ + "static/media/Mark-6-HUD-Targeting (TD).086520a4.jpg";